<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
      /* linkType: {
       type: String,
       default: 'brand',
       validator(value) {
       return [
       'brand',
       'list',
       ].includes(value)
       },
       } */
    },
    methods: {
      // formatLink(data) {
      //   return {
      //     name:  'brand-product-item',
      //     params: {
      //       productAlias: data.alias,
      //       brandAlias: data.brands[0].alias
      //     }
      //   }
      // },
    }
  }
</script>
<template>
  <div :class="$style.listProductItem">
    <div class="listProductItem__content">
      <div class="listProductItem__title">
        {{ data.title }}
      </div>
      <div class="listProductItem__meta">
        {{ data.brands[0].title }}
      </div>
    </div>
    <router-link
      class="listProductItem__link"
      :to="data.to"
    >
    </router-link>
  </div>
</template>
<style lang="scss" module>
  .listProductItem {
    position: relative;
    background: #FFF;
    border-radius: 2px;
    box-shadow: $box-shadow-base;
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: $box-shadow-base-hover;

      :global {
        .listProductItem {
          &__title {
            color: $color-primary;
          }
        }
      }
    }

    :global {
      .listProductItem {
        &__content {
          padding: 1.875rem;

          @include max-md {
            padding: 1rem;
          }
        }

        &__title {
          @include line-clamp(2, 3em);

          margin-bottom: 1.125rem;
          font-size: 1.25rem;
          font-weight: 500;
          line-height: 1.5;

          // @include max-md {
          //   font-size: 1rem;
          // }
          @include max-md {
            font-size: 1rem;
          }
        }

        &__meta {
          font-size: 0.875rem;
          color: $color-gray-6;
        }

        &__link {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
</style>
